<template>
    <div
        class="automation-block-modal"
        v-animate-css="{ classes: 'slideInRight', delay: 0, duration: 500 }"
        :block-type="block.type"
    >
        <div class="main">
            <div class="header">
                <div class="left">
                    <div class="d-flex align-items-center align-content-center justify-content-start pb-2">
                        <BlockIconPreview class="mr-2" style="color: #919ead" :block-type="block.type" />
                        <span class="blockTypeText">{{ $t(`chatbotv2.${block.type}`) }}</span>
                    </div>
                    <div class="name">
                        <BlockTitle :name="block.name" :block="block" :is-save="isSaveProp" />
                    </div>
                </div>
                <div class="right">
                    <button class="chatbot-btn" @click="handleClose()">
                        <md-icon>close</md-icon>
                    </button>
                    <button class="chatbot-btn" @click="updatePayload()" v-if="!previewMode">
                        <md-icon>save</md-icon>
                    </button>
                </div>
            </div>
            <div class="body">
                <span class="bg-primary text-light p-3 w-100 d-block" v-if="previewMode">
                    {{ $t("chatbotv2.previewModeCaution") }}
                </span>

                <div class="payload-wrapper" v-if="!payload">
                    {{ $t("chatbotv2.addPayload") }}
                </div>
                <div v-else class="payload-wrapper">
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.FILTER">
                        <FilterBlock v-model="payload" :automation="automation" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.WEBHOOK">
                        <Webhook v-model="payload" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.SEND_JSON_RESPONSE">
                        <SendJsonResponse v-model="payload" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.SLEEP">
                        <Sleep v-model="payload" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.ASK_AI">
                        <AskAI v-model="payload" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.CREATE_CONTACT">
                        <CreateContact v-model="payload" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.UPDATE_CONTACT">
                        <UpdateContact v-model="payload" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.TERMINATE_AUTOMATION">
                        <TerminateAutomation v-model="payload" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.SEND_WP_BUSINESS_MESSAGE">
                        <SendWhatsappTemplateMessage v-model="payload" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.LOOP">
                        <Loop v-model="payload" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.FIND_CONTACTS">
                        <FindContacts v-model="payload" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.FIND_CONTACT">
                        <FindContact v-model="payload" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.STRING_FORMAT">
                        <StringFormatter v-model="payload" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.NUMBER_FORMAT">
                        <NumberFormatterChain v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.DATE_FORMAT">
                        <DateFormatChain v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.RECORDS_FROM_CSV">
                        <RecordsFromCSV v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.WAIT_FOR">
                        <WaitFor v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.SEND_MAIL">
                        <SendMail v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.CREATE_TICKET">
                        <CreateTicket v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.TABLE_UPDATE_RECORD">
                        <UpdateRecord v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.TABLE_CREATE_RECORD">
                        <CreateRecord v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.TABLE_FIND_RECORD">
                        <FindRecord v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.TABLE_FIND_RECORDS">
                        <FindRecords v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.TABLE_DELETE_RECORD">
                        <DeleteRecord v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.ZOHO_FIND_RECORDS_BY_PHONE">
                        <ZohoFindRecordsByPhone v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.ZOHO_ADD_ATTACHMENT_TO_RECORD">
                        <ZohoAddAttachmentToRecord v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD">
                        <ZohoUploadImageToField v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.ZOHO_CREATE_RECORD">
                        <ZohoCreateRecord v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.GET_SUPSIS_RECORD_BY_ID">
                        <GetSupsisRecordById v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.SHOW_WIDGET">
                        <ShowWidget v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.GO_TO_STEP">
                        <GotoStep
                            v-model="payload"
                            :flatted-diagram="flattedDiagram"
                            :isGotoStep="block.type === AUTOMATION_BLOCK_TYPES.GO_TO_STEP"
                        />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.TICKET_UPDATE">
                        <TicketUpdate v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.UPDATE_TASK">
                        <UpdateTask v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.CREATE_TASK">
                        <CreateTask v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.ASSIGN_OWNER">
                        <AssignOwner v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.SEND_SMS">
                        <SendSMS v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.AI_CALL">
                        <AICall v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.RUN_JAVASCRIPT">
                        <RunJavaScript v-model="payload" :block-id="block.id" :automation="automation" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.META_SEND_CAPI_EVENT">
                        <MetaSendCapiEvent v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.CACHE_WRITE">
                        <CacheWrite v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.CACHE_READ">
                        <CacheRead v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.CACHE_EXTEND">
                        <CacheExtend v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.CACHE_DELETE">
                        <CacheDelete v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.YOUTUBE_REPLY_COMMENT">
                        <YouTubeReplyComment v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.YOUTUBE_UPDATE_COMMENT_STATUS">
                        <YouTubeUpdateCommentStatus v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.YOUTUBE_SET_MODERATION_STATUS">
                        <YouTubeSetModerationStatus v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.GOOGLE_BUSINESS_REPLY_REVIEW">
                        <GoogleBusinessReplyReview v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS">
                        <GoogleBusinessUpdateReviewStatus v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.GOOGLE_PLAY_REPLY_REVIEW">
                        <GooglePlayReplyReview v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.GOOGLE_PLAY_UPDATE_REVIEW_STATUS">
                        <GooglePlayUpdateReviewStatus v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.APP_STORE_REPLY_REVIEW">
                        <AppStoreReplyReview v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.APP_STORE_UPDATE_REVIEW_STATUS">
                        <AppStoreUpdateReviewStatus v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === AUTOMATION_BLOCK_TYPES.APP_STORE_DELETE_REVIEW_RESPONSE">
                        <AppStoreDeleteReviewResponse v-model="payload" :block-id="block.id" />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import _ from "lodash";
import log2 from "../../../../../../utils/log2";
import BlockIconPreview from "../common/BlockIconPreview.vue";
import { ActionPalette } from "../../../BlockConfiguration";
import BlockTitle from "./BlockTitle.vue";
import AUTOMATION_BLOCK_TYPES from "../../../AutomationBlockTypes";

const { Payloads } = require("../../../BlockConfiguration");

import StringUtils from "../../../../../../utils/StringUtils";

import FilterBlock from "../blocks/filter/FilterBlock.vue";
import Webhook from "../blocks/webhook/Webhook.vue";
import TerminateAutomation from "../blocks/TerminateAutomation.vue";
import Sleep from "../blocks/Sleep.vue";
import AskAI from "../blocks/contact/AskAI.vue";
import CreateContact from "../blocks/contact/CreateContact.vue";
import UpdateContact from "../blocks/contact/UpdateContact.vue";
import SendWhatsappTemplateMessage from "../blocks/SendWhatsappTemplateMessage.vue";
import Loop from "../blocks/loop/Loop.vue";
import FindContacts from "../blocks/contact/FindContacts.vue";
import StringFormatter from "../blocks/formatter/string/StringFormatter.vue";
import NumberFormatter from "../blocks/formatter/number/NumberFormatter.vue";
import NumberFormatterChain from "../blocks/formatter/number/NumberFormatChain.vue";
import RecordsFromCSV from "../blocks/file/RecordsFromCSV.vue";
import DateFormatChain from "../blocks/formatter/date/DateFormatChain.vue";
import WaitFor from "../blocks/WaitFor.vue";
import SendMail from "../blocks/SendMail.vue";
import GotoStep from "../blocks/GotoStep.vue";
import FindContact from "../blocks/contact/FindContact.vue";
import CreateTicket from "../blocks/CreateTicket.vue";
import UpdateRecord from "../blocks/table/UpdateRecord.vue";
import CreateRecord from "../blocks/table/CreateRecord.vue";
import FindRecords from "../blocks/table/FindRecords.vue";
import FindRecord from "../blocks/table/FindRecord.vue";
import DeleteRecord from "../blocks/table/DeleteRecord.vue";
import ZohoFindRecordsByPhone from "../blocks/zoho/ZohoFindRecordsByPhone.vue";
import ZohoAddAttachmentToRecord from "../blocks/zoho/ZohoAddAttachmentToRecord.vue";
import ZohoUploadImageToField from "../blocks/zoho/ZohoUploadImageToField.vue";
import ZohoCreateRecord from "../blocks/zoho/ZohoCreateRecord.vue";
import GetSupsisRecordById from "../blocks/GetSupsisRecordById.vue";
import ShowWidget from "../blocks/ShowWidget.vue";
import TicketUpdate from "../blocks/TicketUpdate.vue";
import UpdateTask from "../blocks/UpdateTask.vue";
import CreateTask from "../blocks/CreateTask.vue";
import AssignOwner from "../blocks/AssignOwner.vue";
import ReplyTrendyolQuestion from "../blocks/ReplyTrendyolQuestion.vue";
import SendSMS from "../blocks/SendSMS.vue";
import AICall from "../blocks/AICall.vue";
import SendJsonResponse from "../blocks/webhook/SendJsonResponse.vue";
import RunJavaScript from "../blocks/RunJavaScript.vue";
import MetaSendCapiEvent from "../blocks/MetaSendCapiEvent.vue";
import CacheWrite from "../blocks/cache/CacheWrite.vue";
import CacheRead from "../blocks/cache/CacheRead.vue";
import CacheExtend from "../blocks/cache/CacheExtend.vue";
import CacheDelete from "../blocks/cache/CacheDelete.vue";
import YouTubeReplyComment from "../blocks/YouTubeReplyComment.vue";
import YouTubeUpdateCommentStatus from "../blocks/YouTubeUpdateCommentStatus.vue";
import YouTubeSetModerationStatus from "../blocks/YouTubeSetModerationStatus.vue";
import GoogleBusinessReplyReview from "../blocks/GoogleBusinessReplyReview.vue";
import GoogleBusinessUpdateReviewStatus from "../blocks/GoogleBusinessUpdateReviewStatus.vue";
import GooglePlayReplyReview from "../blocks/GooglePlayReplyReview.vue";
import GooglePlayUpdateReviewStatus from "../blocks/GooglePlayUpdateReviewStatus.vue";
import AppStoreReplyReview from "../blocks/AppStoreReplyReview.vue";
import AppStoreUpdateReviewStatus from "../blocks/AppStoreUpdateReviewStatus.vue";
import AppStoreDeleteReviewResponse from "../blocks/AppStoreDeleteReviewResponse.vue";

const log = log2("BlockModal");
export default {
    name: "BlockModal",
    components: {
        SendSMS,
        ZohoCreateRecord,
        ZohoUploadImageToField,
        ZohoAddAttachmentToRecord,
        ZohoFindRecordsByPhone,
        DeleteRecord,
        FindRecord,
        FindRecords,
        CreateRecord,
        UpdateRecord,
        CreateTicket,
        AskAI,
        FindContact,
        GotoStep,
        SendMail,
        WaitFor,
        DateFormatChain,
        RecordsFromCSV,
        NumberFormatterChain,
        NumberFormatter,
        StringFormatter,
        FindContacts,
        Loop,
        SendWhatsappTemplateMessage,
        Sleep,
        TerminateAutomation,
        Webhook,
        SendJsonResponse,
        FilterBlock,
        BlockIconPreview,
        BlockTitle,
        CreateContact,
        UpdateContact,
        GetSupsisRecordById,
        TicketUpdate,
        UpdateTask,
        CreateTask,
        AssignOwner,
        ReplyTrendyolQuestion,
        ShowWidget,
        AICall,
        RunJavaScript,
        MetaSendCapiEvent,
        CacheWrite,
        CacheRead,
        CacheExtend,
        CacheDelete,
        YouTubeReplyComment,
        YouTubeUpdateCommentStatus,
        YouTubeSetModerationStatus,
        GoogleBusinessReplyReview,
        GoogleBusinessUpdateReviewStatus,
        GooglePlayReplyReview,
        GooglePlayUpdateReviewStatus,
        AppStoreReplyReview,
        AppStoreUpdateReviewStatus,
        AppStoreDeleteReviewResponse,
    },
    props: ["block", "automation", "flattedDiagram", "previewMode"],
    data() {
        return {
            Payloads,
            ActionPalette,
            payload: null,
            didChanged: false,
            isSaveProp: false,
            AUTOMATION_BLOCK_TYPES,
        };
    },
    methods: {
        ...mapActions({
            updateBlock: "automation/updateBlock",
        }),
        async updatePayload(fromOutside = false) {
            if (this.previewMode) return;
            if (fromOutside && !this.didChanged) return false;
            try {
                if (fromOutside) {
                    await this.$dialog.confirm(this.$t("chatbotv2.blockChangedWannaUpdate"), {
                        okText: this.$t("message.yes"),
                        cancelText: this.$t("message.no"),
                    });
                }
                this.isSaveProp = true;
                await this.updateBlock({
                    id: this.automation._id,
                    blockId: this.block.id,
                    payload: {
                        payload: this.payload,
                    },
                }).catch(_.noop);

                if (!fromOutside) {
                    this.$toasted.success(this.$t("chatbotv2.blockUpdated"), {
                        duration: 2000,
                        position: "bottom-center",
                    });
                    this.$emit("close");
                }
                return true;
            } catch (e) {
                return false;
            }
        },
        async handleClose() {
            // RunJavaScript bloğu için özel unsaved changes kontrolü
            if (this.block.type === this.AUTOMATION_BLOCK_TYPES.RUN_JAVASCRIPT) {
                const runJsComponent = this.$children.find(child => 
                    child.$options.name === 'RunJavaScript'
                );
                
                if (runJsComponent && runJsComponent.checkUnsavedChanges && runJsComponent.checkUnsavedChanges()) {
                    try {
                        await this.$dialog.confirm(
                            'Kaydedilmemiş değişiklikleriniz var. Kaydetmeden çıkmak istediğinizden emin misiniz?',
                            {
                                title: 'Kaydedilmemiş Değişiklikler',
                                okText: 'Evet, Çık',
                                cancelText: 'İptal',
                                type: 'warning'
                            }
                        );
                    } catch (error) {
                        // Kullanıcı iptal etti, modal açık kalsın
                        return;
                    }
                }
            }
            
            this.$emit('close');
        },
    },
    mounted() {
        if (!!this.block.payload) this.payload = _.cloneDeep(this.block.payload);
        else this.payload = _.cloneDeep(_.get(Payloads, [this.block.type, "default"]) || {});
    },
    watch: {
        payload: {
            deep: true,
            handler(nV, oV) {
                if (!this.didChanged && !StringUtils.isDeepEqual(nV, this.block.payload) && oV !== null) {
                    if (this.previewMode) {
                        this.$message.error("Cannot update  in preview mode");
                        return;
                    }
                    this.didChanged = true;
                }
            },
        },
    },
};
</script>

<style lang="scss">
.automation-block-modal {
    position: fixed;
    right: 1rem;
    top: 1rem;
    z-index: 999;
    display: flex;
    align-items: flex-start;

    .ant-select-selection-selected-value {
        .row {
            flex-wrap: nowrap !important;
        }
    }

    .icon-preview-block-modal {
        font-size: 19px;
        padding-top: 1px;
    }

    &[block-type="SEND_WP_BUSINESS_MESSAGE"] {
        .main {
            width: 750px !important;
            max-width: 100% !important;
        }
    }
    &[block-type="RUN_JAVASCRIPT"] {
        .main {
            width: 90vw !important;
            max-width: 100% !important;
        }
    }

    .main {
        max-width: 1000px;
        width: 1000px;
        overflow-x: hidden;

        .header {
            padding: 1rem 1.5rem 1rem 2rem;
            margin-left: 2rem;
            background: #fff;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;

            .left {
                .type {
                    color: #919ead;
                    font-weight: 600;
                    text-transform: uppercase;
                }

                .name {
                    font-weight: bold;
                    font-size: 1.5rem;
                }

                .custom-block-logo {
                    width: 24px;
                    height: 24px;
                }
            }

            .right {
                position: absolute;
                top: 0.5rem;
                right: 1rem;
                display: flex;
                gap: 0.5rem;

                .chatbot-btn {
                    border: none;
                    background: #dfdfdf;
                    border-radius: 4px;
                    padding: 4px 8px;
                    margin: 0;
                    min-height: 34px;
                    min-width: 34px;
                    color: #000;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    &.bordered {
                        border: 1px solid #000;
                    }
                }
            }
        }

        .body {
            padding-left: 2rem;
            max-height: calc(100vh - 140px);
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-track {
                background: #f1f1f1;
                border-radius: 3px;
            }

            &::-webkit-scrollbar-thumb {
                background: #c1c1c1;
                border-radius: 3px;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: #a1a1a1;
            }

            .payload-wrapper {
                display: flex;
                flex-direction: column;
                gap: 1rem;
                background: #dfdfdf;
                padding: 1rem 0;
            }

            .payload {
                padding: 0 1.5rem;
                position: relative;

                input[type="checkbox"] {
                    display: none;

                    & + input {
                        display: none;
                    }

                    &:checked + input {
                        display: block;
                    }
                }

                textarea {
                    width: 100%;
                    resize: none;
                    height: 100px;
                    border: 1px solid transparent;
                    border-radius: 12px;
                    padding: 6px 12px;

                    &::-webkit-scrollbar {
                        display: none;
                    }

                    &:focus {
                        border-color: #06a9f3;
                    }
                }

                label {
                    display: flex;
                    gap: 1rem;
                    align-items: center;

                    span {
                        background: #888888;
                        padding: 0.4rem 0.7rem;
                        border-radius: 1rem;
                        color: #ffffff;
                        user-select: none;
                        transition: all 0.3s ease-in-out;
                        cursor: pointer;
                        min-width: 100px;
                        text-align: center;

                        &:hover {
                            background: #a2a2a2;
                        }
                    }

                    .attr-val {
                        width: 100%;
                        resize: none;
                        border: 1px solid #a2a2a2;
                        border-radius: 2px;
                        padding: 0.3rem 0.9rem;

                        &:focus {
                            border: 1px solid #0651f3;
                        }
                    }
                }

                .toolbar {
                    opacity: 0;
                    transition: all 0.3s ease-in-out;
                    position: absolute;
                    left: -17px;
                    bottom: 0;
                    top: 28px;
                    display: flex;
                    flex-direction: column;
                    //justify-content: center;
                    gap: 0.6rem;

                    .toolbar-btn {
                        border: none;
                        background: #ffffff;
                        border-radius: 50%;
                        margin: 0;
                        //height: 34px;
                        //width: 34px;
                        min-height: 30px;
                        min-width: 30px;
                        color: #000;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        box-shadow: 0 4px 20px #00000040;

                        &.bordered {
                            border: 1px solid #000;
                        }
                    }
                }

                &:hover .toolbar {
                    opacity: 1;
                }

                .chatbot-btn {
                    border: none;
                    background: #bd5555;
                    border-radius: 4px;
                    padding: 4px 8px;
                    margin: 0;
                    min-height: 34px;
                    min-width: 34px;
                    color: #000;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    right: 10px;
                    top: 60px;

                    i {
                        color: #ffffff;
                    }

                    &.bordered {
                        border: 1px solid #000;
                    }
                }

                .keywords {
                    display: flex;
                    flex-wrap: wrap;
                    max-width: 430px;
                    gap: 0.4rem;
                    margin: 1rem 0;

                    .keyword {
                        border: 1px dashed #aaa;
                        border-radius: 1.5rem;
                        padding: 0.5rem 1rem;
                        background: transparent;
                        text-align: center;
                        transition: all 0.3s ease-in-out;
                        font-weight: bold;
                        max-width: 80px;

                        &::placeholder {
                            color: #000;
                        }

                        &:focus {
                            border: 1px solid;
                        }

                        &.filled:not(:focus) {
                            border: 1px solid #0651f3;
                            background-color: #0651f3;
                            color: #ffffff;
                        }
                    }
                }

                .says {
                    display: flex;
                    flex-direction: column;
                    gap: 0.4rem;
                    margin: 1rem 0;

                    .say {
                        width: 100%;
                        resize: none;
                        border: 1px solid transparent;
                        border-radius: 12px;
                        padding: 14px;

                        &:focus {
                            border: 1px solid #0651f3;
                        }
                    }
                }
            }

            .cbcard {
                background-color: #ffffff;
                border-radius: 4px;
                margin: 0 1.5rem;
                padding: 1rem;
            }

            .cbcard-btn {
                border: none;
                background: #fff;
                align-self: center;
                border-radius: 50%;
                height: 36px;
                transform: scale(0.7);

                &::before {
                    content: "";
                    width: 2px;
                    height: 1.9rem;
                    display: block;
                    z-index: -3;
                    position: absolute;
                    bottom: 100%;
                    left: 50%;
                    transform: translateX(-50%);
                    border: 1px dashed #888888;
                }
            }

            .condition-card {
                display: flex;
                margin-bottom: 1rem;
            }

            .cbcondition-btn {
                width: 100%;
                padding: 8px 15px;
                border-radius: 4px;
                border: 1px solid #dadada;
                transition: all 0.3s ease-in-out;
                background-color: #ffffff;

                &:hover {
                    border: 1px solid #06a9f3;
                    color: #06a9f3;
                }
            }
        }
    }

    .ant-divider-horizontal.ant-divider-with-text-center::before,
    .ant-divider-horizontal.ant-divider-with-text-center::after {
        border-top: 1px solid #a8a8a8;
    }
}
</style>
